import { ArrowRight } from "lucide-react";

const QW_HIGHLIGHT =
  "https://qwilr.imgix.net/pnXKj2R3ch9iFqkG0SE1bxrZnoKAkFw4aZjreA.jpeg?auto=format&w=2000&q=85";

function servicesGridClass(count) {
  if (count >= 3) return "md:grid-cols-3 max-w-6xl";
  if (count === 2) return "md:grid-cols-2 max-w-4xl";
  return "md:grid-cols-1 max-w-xl";
}

export function ServicesSection({ services }) {
  return (
    <section data-track-section="services" className="relative w-full overflow-hidden">
      <img src={QW_HIGHLIGHT} alt="" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-black/55" />
      <div className="relative z-10 px-6 md:px-12 lg:px-16 py-24 md:py-32">
        <div
          className={`grid grid-cols-1 gap-6 md:gap-8 mx-auto items-start ${servicesGridClass(services.length)}`}
        >
          {services.map((s) => (
            <div
              key={s.key}
              data-testid={`service-${s.key}`}
              className="flex flex-col bg-white/10 hover:bg-white/15 backdrop-blur-md border border-white/20 hover:border-white/40 p-8 md:p-10 transition-all duration-300"
            >
              <h3 className="font-display text-white text-3xl md:text-4xl tracking-tight leading-tight mb-5">
                {s.title}
              </h3>
              <p className="text-white/85 leading-relaxed mb-8 text-sm md:text-base">{s.body}</p>
              <a
                href={s.href}
                data-track-click={`example-${s.key}`}
                target="_blank"
                rel="noreferrer"
                className="mt-auto inline-flex items-center gap-2 text-white text-xs tracking-overline uppercase font-medium border-b border-white/60 hover:border-white pb-1 self-start group"
              >
                {s.label}
                <ArrowRight
                  className="w-3.5 h-3.5 group-hover:translate-x-1 transition-transform"
                  strokeWidth={1.5}
                />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
